export const DISPLAY_AD_CLASS = "display-🤑";
export const DISPLAY_AD_WIDTH = 300;
export const DISPLAY_AD_HEIGHT = 250;
